import React from 'react';
import { TemplateGroupContainer, TemplateGroupTitle, TemplateGroupWrapper } from './TemplateGroup.styled';
import { ITemplateGroup } from '../../Collection';
import {
  TemplateWrapper,
  Template,
  TemplateRadio,
  TemplateRadioPicker,
  TemplateTitle,
} from '../Template/Template.styled';
import config from './../../../../config';
import DownloadIcons from '../../../../public/images/download-icons';
import { premiumForecasts } from '../../../../redux/reducers/premiumSlice';
import PremiumPopper from '../../../PremiumTag/PremiumPopper';
import { trimTrailingSlash } from '@emarketer/code-helpers';

interface ITemplateGroupProps {
  group: ITemplateGroup;
  selectedTemplateId: string;
  collectionId: string;
  collectionType: string;
  onClick;
}

const TemplateGroup: React.FC<ITemplateGroupProps> = (props) => {
  const { group, selectedTemplateId, collectionId, collectionType, onClick } = props;

  const checkTemplateForPremium = (templateId) => {
    return premiumForecasts.some((f) => f.collectionId === collectionId && f.templateId === templateId);
  };
  const displayPremiumFeatures = (templateId) => config.enableNonPremiumFeatures && checkTemplateForPremium(templateId);

  const templates = group.Templates.map((template, index) => (
    <TemplateWrapper
      onClick={() => onClick(collectionType, collectionId, template.Id, selectedTemplateId)}
      key={template.Id}
    >
      <Template>
        <TemplateRadio justifyContent="start" alignItems="center" flexDirection="row" spaceBetween={8}>
          <TemplateRadioPicker
            type="radio"
            name={template.Id}
            checked={template.Id === selectedTemplateId}
            readOnly
            width="15"
            height="15"
            alt="Collection Picker Radio"
          />
          <TemplateTitle
            selected={template.Id === selectedTemplateId}
            href={`${trimTrailingSlash(config.publicPath)}/${collectionId}/${template.Id}`}
          >
            {template.Name}
          </TemplateTitle>
          {displayPremiumFeatures(template.Id) && <PremiumPopper />}
        </TemplateRadio>
      </Template>
    </TemplateWrapper>
  ));

  return (
    <TemplateGroupWrapper>
      <TemplateGroupTitle>{group.Name}</TemplateGroupTitle>
      <TemplateGroupContainer justifyContent="start" alignItems="stretch" spaceBetween={16}>
        {templates}
      </TemplateGroupContainer>
      <DownloadIcons />
    </TemplateGroupWrapper>
  );
};

export default TemplateGroup;
